/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetClientWithContactsDto } from './GetClientWithContactsDto';
import {
    GetClientWithContactsDtoFromJSON,
    GetClientWithContactsDtoFromJSONTyped,
    GetClientWithContactsDtoToJSON,
} from './GetClientWithContactsDto';

/**
 * 
 * @export
 * @interface GetClientGroupItemDto
 */
export interface GetClientGroupItemDto {
    /**
     * 
     * @type {string}
     * @memberof GetClientGroupItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetClientGroupItemDto
     */
    clientGroupId: string;
    /**
     * 
     * @type {GetClientWithContactsDto}
     * @memberof GetClientGroupItemDto
     */
    client: GetClientWithContactsDto;
}

/**
 * Check if a given object implements the GetClientGroupItemDto interface.
 */
export function instanceOfGetClientGroupItemDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "clientGroupId" in value;
    isInstance = isInstance && "client" in value;

    return isInstance;
}

export function GetClientGroupItemDtoFromJSON(json: any): GetClientGroupItemDto {
    return GetClientGroupItemDtoFromJSONTyped(json, false);
}

export function GetClientGroupItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClientGroupItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'clientGroupId': json['clientGroupId'],
        'client': GetClientWithContactsDtoFromJSON(json['client']),
    };
}

export function GetClientGroupItemDtoToJSON(value?: GetClientGroupItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'clientGroupId': value.clientGroupId,
        'client': GetClientWithContactsDtoToJSON(value.client),
    };
}

